import { memo } from 'react';

import { Button } from 'antd';

function AuthFooter({ isSignUpMode, switchToSignIn }) {
  return (
    <>
      {isSignUpMode ? (
        <div className="text-center">
          Already have an account?{' '}
          <Button type="link" onClick={switchToSignIn}>
            Sign In
          </Button>
        </div>
      ) : (
        <div className="text-center">
          <p className="m-0">Don&apos;t have an account?</p>
          <a href="https://kraal.farm/" target="_blank" rel="noopener noreferrer">
            Become a customer
          </a>{' '}
          or <a href="mailto:contact@kraal.farm?subject=Kraal user account enquiry">contact us</a>
        </div>
      )}
    </>
  );
}

export default memo(AuthFooter);
